module.exports = __webpack_public_path__ + "static/media/plotter5.91e7dc5d.png";